import { cn } from "@/lib/utils";

interface Props {
  className?: string;
}

function ValueSkeleton(props: Props) {
  return (
    <div
      className={cn(
        "flex w-full flex-1 h-[25px] p-1 rounded-md bg-gray-300 dark:bg-mfdarklighter animate-pulse",
        props.className
      )}
    />
  );
}

export default ValueSkeleton;
